import {
  formatChange,
  validateInput,
  convertTo24Hour,
} from "../services/timeFormat";
import { timeFormatChange } from "../services/trackerServices";

/**
 * Factory function to create time input validation handler
 * @param {Object} params - Parameters object
 * @param {Object} params.startInputRef - Ref for 24hr start input
 * @param {Object} params.endInputRef - Ref for 24hr end input
 * @param {Object} params.start12HrTimeInputRef - Ref for 12hr start input
 * @param {Object} params.end12HrTimeInputRef - Ref for 12hr end input
 * @param {string} params.startTimeManual - Start time in 12hr format
 * @param {string} params.endTimeManual - End time in 12hr format
 * @param {string} params.startTimeTemp - Temporary start time
 * @param {string} params.endTimeTemp - Temporary end time
 * @param {Function} params.manualChangeStartTime24 - Handler for 24hr start time change
 * @param {Function} params.manualChangeEndTime24 - Handler for 24hr end time change
 * @param {Function} params.manualChangeStartTime - Handler for 12hr start time change
 * @param {Function} params.manualChangeEndTime - Handler for 12hr end time change
 * @returns {Function} Click outside handler function
 */
export const createTimeInputValidationHandler = ({
  startInputRef,
  endInputRef,
  start12HrTimeInputRef,
  end12HrTimeInputRef,
  startTimeManual,
  endTimeManual,
  startTimeTemp,
  endTimeTemp,
  manualChangeStartTime24,
  manualChangeEndTime24,
  manualChangeStartTime,
  manualChangeEndTime,
}) => {
  return (event) => {
    try {
      if (
        startInputRef.current &&
        !startInputRef.current.contains(event.target)
      ) {
        if (
          formatChange(startInputRef.current.value) &&
          validateInput(startInputRef.current.value)
        ) {
          manualChangeStartTime24(startInputRef.current.value);
        } else {
          manualChangeStartTime24(convertTo24Hour(startTimeManual));
        }
      }

      if (
        endInputRef.current &&
        !endInputRef.current.contains(event.target)
      ) {
        if (formatChange(endInputRef.current.value)) {
          manualChangeEndTime24(endInputRef.current.value);
        } else {
          manualChangeEndTime24(convertTo24Hour(endTimeManual));
        }
      }

      if (
        start12HrTimeInputRef.current &&
        !start12HrTimeInputRef.current.contains(event.target)
      ) {
        const formattedTime = timeFormatChange(
          start12HrTimeInputRef.current.value
        );
        if (formattedTime === false) {
          manualChangeStartTime(startTimeTemp);
        } else {
          manualChangeStartTime(start12HrTimeInputRef.current.value);
        }
      }

      if (
        end12HrTimeInputRef.current &&
        !end12HrTimeInputRef.current.contains(event.target)
      ) {
        const formattedTime = timeFormatChange(
          end12HrTimeInputRef.current.value
        );
        if (formattedTime === false) {
          manualChangeEndTime(endTimeTemp);
        } else {
          manualChangeEndTime(end12HrTimeInputRef.current.value);
        }
      }
    } catch (innerError) {
      console.error("Error in handleClickOutside:", innerError);
    }
  };
};
